module.exports = __webpack_public_path__ + "img/流体力学3_2_4.837c358b.jpg";